// extracted by mini-css-extract-plugin
module.exports = {"tag":"nzYEfp","image":"_3-xapk","shine-lines":"ovDtYn"};